import { Severity } from './severity.enum'
import { LogSourceLevel } from './log-source-level.enum'
import { LogEventType } from './log-event-type.enum';

export class LogEntry {
  application: string;
  appVersion: string;
  moduleName: string;
  logEventType: LogEventType;
  logSourceLevel: LogSourceLevel;
  severity: Severity;
  message: string;
  timestamp: Date;
  clientRefCode: string;
  tags?: string[];

  constructor(application: string, appVersion: string, moduleName: string, logEventType: LogEventType,
    source: LogSourceLevel, severity: Severity, message: string, clientRefCode: string, tags?: string[] | null) {
    this.application = application;
    this.appVersion = appVersion;
    this.moduleName = moduleName;
    this.logEventType = logEventType
    this.logSourceLevel = source;
    this.severity = severity;
    this.message = message;
    this.clientRefCode = clientRefCode;
    this.timestamp = new Date(Date.now());
    this.tags = tags;
  }
}
